import styled, { css } from 'styled-components'
import { WhiteBlock } from 'components/Layout'
import CommonButton from 'components/Button/CommonButton'
import theme from 'theme_'

const NetworkStatusItemBase = css`
  min-height: 160px;
  width: 100%;
`

export const NetworkStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.base};
`

export const NetworkStatusBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.base};
  width: 100%;
  @media ${theme.devices.tabletLandscape} {
    flex-direction: row;
    gap: ${theme.spacing.xs};
  }
`
export const NetworkIntroBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.base};
  width: 100%;
  line-height: 24px;
  @media ${theme.devices.tabletLandscape} {
    flex-direction: row;
    gap: ${theme.spacing.xs};
  }
`

export const NetworkStatusHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const NetworkStatusItem = styled(WhiteBlock)<{
  disabled?: boolean
}>`
  justify-content: space-between;
  ${NetworkStatusItemBase};
  background-color: ${theme.colors.white};
  padding: ${theme.spacing.base};
  gap: ${theme.spacing.sm};
`

export const VisitMistButton = styled(CommonButton)`
  text-transform: capitalize;
  font-weight: 900;
  min-height: 40px;
  border-radius: 8px;
  background: transparent;
  padding: ${theme.spacing.xs} ${theme.spacing.base};
  @media ${theme.devices.tablet} {
    padding: ${theme.spacing.s} ${theme.spacing.lg};
  }
  && {
    appearance: none;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }
`
